(function($) {
    function init_hover_content(){
        // Bind hover content elements
        let $container = $('[block-name="hover-content"]');
        let $controls = $container.find('.hover-content__control-panel .button');

        // Set behaviours for mouse enter and mouse leave
        $controls.hover(
            //-- Mouse enter --//
            function(){
                // Grab item index of current hovered item on mouse enter and set active state
                let $itemIndex = $(this).data('item-index');

                $('.hover-content__item[data-item-index=' + $itemIndex + '], .hover-content__container').addClass('active');
                $('.hover-content__container img[data-item-index=' + $itemIndex + ']').addClass('active');
            },
            //-- Mouse leave --//
            function(){
                // Grab item index of previous hovered item on mouse enter and remove active state
                let $itemIndex = $(this).data('item-index');

                $('.hover-content__item[data-item-index=' + $itemIndex + '], .hover-content__container').removeClass('active');
                $('.hover-content__container img[data-item-index=' + $itemIndex + ']').removeClass('active');
            });
    }

    //close other accordions when a new one is opened
    $('.accordion').on('click', function() {

        // Toggle accordion content
        $('.accordion.active .accordion__content').not($(this).find('.accordion__content')).slideUp();

        // Toggle accordion state, set aria-expanded false and icon inactive state
        $('.accordion.active').not(this).toggleClass('active')
            .find('.accordion__heading').attr('aria-expanded', false);
    })

    $(() => {
        // Init hover content switch
        if($('[block-name="hover-content"]').length) init_hover_content();
    });
})(jQuery);
